// Icônes du dashboard boutique, exportées depuis le design system Figma (nodes 10715:55849).
// Chaque tracé hérite de `currentColor` : la couleur vient du conteneur, comme dans la maquette.
// Le SVG garde ses dimensions natives et se centre dans la boîte fournie par l'appelant.

export function AlertSquareIcon({ className }: { className?: string }) {
  return (
    <svg
      width="17.3333"
      height="17.3333"
      viewBox="0 0 17.3333 17.3333"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M0.750001 8.66667C0.750001 4.93471 0.750001 3.06874 1.90937 1.90937C3.06874 0.750001 4.93471 0.750001 8.66667 0.750001C12.3986 0.750001 14.2646 0.750001 15.424 1.90937C16.5833 3.06874 16.5833 4.93471 16.5833 8.66667C16.5833 12.3986 16.5833 14.2646 15.424 15.424C14.2646 16.5833 12.3986 16.5833 8.66667 16.5833C4.93471 16.5833 3.06874 16.5833 1.90937 15.424C0.750001 14.2646 0.750001 12.3986 0.750001 8.66667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66667 5.33333V9.08333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.66667 11.9902V11.9986"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function BookOpenIcon({ className }: { className?: string }) {
  return (
    <svg
      width="21.5"
      height="21.5026"
      viewBox="0 0 21.5 21.5026"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M16.2555 0.77029C11.5789 1.5861 10.75 6.25155 10.75 6.25155V20.7515C10.75 20.7515 11.6368 15.8788 16.7504 15.3104C17.2993 15.2493 17.75 14.8091 17.75 14.2574V2.14464C17.75 1.31695 17.0716 0.627927 16.2555 0.77029Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.08334 3.75156C6.5438 3.74812 8.91852 4.63863 10.75 6.25155V20.7515C8.91852 19.1386 6.5438 18.2481 4.08334 18.2516C2.52133 18.2516 1.74032 18.2516 1.39527 18.0307C1.18811 17.8981 1.10346 17.8135 0.970864 17.6063C0.750006 17.2612 0.750006 16.6456 0.750006 15.4144V7.15476C0.750006 5.72698 0.750006 5.01309 1.29875 4.43441C1.84749 3.85572 2.40923 3.82587 3.53272 3.76615C3.71501 3.75646 3.89859 3.75156 4.08334 3.75156Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 20.7526C12.5815 19.1397 14.9562 18.2491 17.4167 18.2526C18.9787 18.2526 19.7597 18.2526 20.1047 18.0317C20.3119 17.8991 20.3965 17.8145 20.5291 17.6073C20.75 17.2623 20.75 16.6467 20.75 15.4154V7.15579C20.75 5.728 20.75 5.01411 20.2013 4.43543C19.6525 3.85675 18.8735 3.81126 17.75 3.75155"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function Camera01Icon({ className }: { className?: string }) {
  return (
    <svg
      width="21.5001"
      height="18.5001"
      viewBox="0 0 21.5001 18.5001"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M11.4473 0.750115H10.0528C9.33826 0.750115 8.98098 0.750115 8.66054 0.862113C8.46486 0.930507 8.281 1.0289 8.11555 1.15378C7.84461 1.35828 7.64643 1.65556 7.25005 2.25012L7.25004 2.25013C7.04704 2.55464 6.74781 3.00348 6.62854 3.12882C6.33301 3.43939 5.9455 3.64678 5.52316 3.7204C5.35271 3.75012 5.16972 3.75012 4.80374 3.75012C3.82367 3.75012 3.33363 3.75012 2.93295 3.86354C1.93061 4.14727 1.14721 4.93067 0.863477 5.93301C0.750055 6.33369 0.750055 6.82373 0.750055 7.8038V11.7501C0.750055 14.5785 0.750055 15.9928 1.62873 16.8714C2.50741 17.7501 3.92163 17.7501 6.75005 17.7501H14.7501C17.5785 17.7501 18.9927 17.7501 19.8714 16.8714C20.7501 15.9928 20.7501 14.5785 20.7501 11.7501V7.8038C20.7501 6.82373 20.7501 6.33369 20.6366 5.93301C20.3529 4.93067 19.5695 4.14727 18.5672 3.86354C18.1665 3.75012 17.6764 3.75012 16.6964 3.75012C16.3304 3.75012 16.1474 3.75012 15.9769 3.7204C15.5546 3.64678 15.1671 3.43939 14.8716 3.12882C14.7523 3.00348 14.4531 2.55463 14.2501 2.25012C13.8537 1.65556 13.6555 1.35828 13.3846 1.15378C13.2191 1.0289 13.0353 0.930507 12.8396 0.862113C12.5191 0.750115 12.1618 0.750115 11.4473 0.750115Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7501 10.2501C14.7501 12.4593 12.9592 14.2501 10.7501 14.2501C8.54091 14.2501 6.75005 12.4593 6.75005 10.2501C6.75005 8.04097 8.54091 6.25012 10.7501 6.25012C12.9592 6.25012 14.7501 8.04097 14.7501 10.2501Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7501 6.75012V6.76012"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function ChartUpIcon({ className }: { className?: string }) {
  return (
    <svg
      width="18.5"
      height="19.5"
      viewBox="0 0 18.5 19.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M17.75 8.25V17.25C17.75 17.7159 17.75 17.9489 17.6739 18.1327C17.5724 18.3777 17.3777 18.5724 17.1327 18.6739C16.9489 18.75 16.7159 18.75 16.25 18.75C15.7841 18.75 15.5511 18.75 15.3673 18.6739C15.1223 18.5724 14.9276 18.3777 14.8261 18.1327C14.75 17.9489 14.75 17.7159 14.75 17.25V8.25C14.75 7.78406 14.75 7.55109 14.8261 7.36732C14.9276 7.12229 15.1223 6.92761 15.3673 6.82612C15.5511 6.75 15.7841 6.75 16.25 6.75C16.7159 6.75 16.9489 6.75 17.1327 6.82612C17.3777 6.92761 17.5724 7.12229 17.6739 7.36732C17.75 7.55109 17.75 7.78406 17.75 8.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 0.75H16.75V3.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.25 1.25C16.25 1.25 12.25 6.25 1.75 9.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 11.75V17.25C10.75 17.7159 10.75 17.9489 10.6739 18.1327C10.5724 18.3777 10.3777 18.5724 10.1327 18.6739C9.94891 18.75 9.71594 18.75 9.25 18.75C8.78406 18.75 8.55109 18.75 8.36732 18.6739C8.12229 18.5724 7.92762 18.3777 7.82612 18.1327C7.75 17.9489 7.75 17.7159 7.75 17.25V11.75C7.75 11.2841 7.75 11.0511 7.82612 10.8673C7.92762 10.6223 8.12229 10.4276 8.36732 10.3261C8.55109 10.25 8.78406 10.25 9.25 10.25C9.71594 10.25 9.94891 10.25 10.1327 10.3261C10.3777 10.4276 10.5724 10.6223 10.6739 10.8673C10.75 11.0511 10.75 11.2841 10.75 11.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 14.25V17.25C3.75 17.7159 3.75 17.9489 3.67388 18.1327C3.57239 18.3777 3.37771 18.5724 3.13269 18.6739C2.94891 18.75 2.71594 18.75 2.25 18.75C1.78406 18.75 1.55109 18.75 1.36732 18.6739C1.12229 18.5724 0.927616 18.3777 0.826122 18.1327C0.750002 17.9489 0.750002 17.7159 0.750002 17.25V14.25C0.750002 13.7841 0.750002 13.5511 0.826122 13.3673C0.927616 13.1223 1.12229 12.9276 1.36732 12.8261C1.55109 12.75 1.78406 12.75 2.25 12.75C2.71594 12.75 2.94891 12.75 3.13269 12.8261C3.37771 12.9276 3.57239 13.1223 3.67388 13.3673C3.75 13.5511 3.75 13.7841 3.75 14.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function ChevronRightBigIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24.8"
      height="24.8"
      viewBox="0 0 24.8 24.8"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M9.29995 18.5999C9.29995 18.5999 15.4999 14.0337 15.4999 12.3999C15.4999 10.766 9.2999 6.1999 9.2999 6.1999"
          stroke="currentColor"
          strokeWidth="1.55"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function CleanIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16.5"
      height="16.5"
      viewBox="0 0 16.5 16.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M15.75 0.750002L9.08334 7.83334"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.12145 7.48787C4.0545 8.2807 2.40225 8.1447 0.750006 7.49042C1.16716 12.8592 3.67012 14.924 7.0074 15.75C7.0074 15.75 9.52174 13.972 9.88419 9.7562C9.92344 9.29963 9.94307 9.07134 9.84813 8.81407C9.7532 8.5568 9.56683 8.3723 9.1941 8.0033C8.58107 7.39641 8.27455 7.09297 7.91079 7.01701C7.54702 6.94105 7.07183 7.12332 6.12145 7.48787Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.00001 11.9554C2.00001 11.9554 4.08334 12.3571 6.16667 10.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33334 4.29167C5.33334 4.86697 4.86697 5.33334 4.29167 5.33334C3.71638 5.33334 3.25001 4.86697 3.25001 4.29167C3.25001 3.71637 3.71638 3.25 4.29167 3.25C4.86697 3.25 5.33334 3.71637 5.33334 4.29167Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M7.41667 1.58334V1.66667"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function ClipboardIcon({ className }: { className?: string }) {
  return (
    <svg
      width="21.4999"
      height="21.5"
      viewBox="0 0 21.4999 21.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <g>
          <path
            d="M15.7735 1.78353L14.8189 1.52919C12.1189 0.809814 10.769 0.450127 9.70543 1.06069C8.64191 1.67125 8.28018 3.01362 7.55673 5.69836L6.53361 9.49516C5.81016 12.1799 5.44843 13.5223 6.06246 14.5798C6.67648 15.6373 8.02646 15.997 10.7264 16.7164L11.681 16.9707C14.381 17.6901 15.731 18.0498 16.7945 17.4392C17.858 16.8286 18.2197 15.4863 18.9432 12.8015L19.9663 9.00474C20.6898 6.32 21.0515 4.97763 20.4375 3.92011C19.8234 2.86259 18.4734 2.5029 15.7735 1.78353Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            d="M15.6037 6.18301C15.6037 6.99709 14.94 7.65704 14.1213 7.65704C13.3026 7.65704 12.639 6.99709 12.639 6.18301C12.639 5.36893 13.3026 4.70899 14.1213 4.70899C14.94 4.70899 15.6037 5.36893 15.6037 6.18301Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </g>
        <path
          d="M10.75 19.6963L9.79761 19.9556C7.10398 20.6891 5.75717 21.0558 4.69615 20.4333C3.63512 19.8107 3.27425 18.442 2.55249 15.7046L1.53177 11.8334C0.810017 9.09596 0.449139 7.72725 1.06172 6.64899C1.59162 5.71626 2.74995 5.75022 4.24995 5.7501"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}

export function Contact02Icon({ className }: { className?: string }) {
  return (
    <svg
      width="20.5"
      height="21.5"
      viewBox="0 0 20.5 21.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M2.25 8.75C2.25 4.97876 2.25 3.09315 3.42157 1.92157C4.59315 0.750001 6.47876 0.750001 10.25 0.750001H11.75C15.5212 0.750001 17.4069 0.750001 18.5784 1.92157C19.75 3.09315 19.75 4.97876 19.75 8.75V12.75C19.75 16.5212 19.75 18.4069 18.5784 19.5784C17.4069 20.75 15.5212 20.75 11.75 20.75H10.25C6.47876 20.75 4.59315 20.75 3.42157 19.5784C2.25 18.4069 2.25 16.5212 2.25 12.75V8.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M8.04993 10.7241C7.62332 9.98019 7.41733 9.37277 7.29313 8.75705C7.10943 7.84641 7.52981 6.95686 8.22622 6.38926C8.52055 6.14937 8.85795 6.23133 9.032 6.54358L9.42493 7.24851C9.73638 7.80726 9.8921 8.08663 9.86122 8.38282C9.83033 8.67901 9.62032 8.92024 9.20029 9.4027L8.04993 10.7241ZM8.04993 10.7241C8.91343 12.2297 10.2685 13.5856 11.7759 14.4501M11.7759 14.4501C12.5198 14.8767 13.1272 15.0827 13.743 15.2069C14.6536 15.3906 15.5431 14.9702 16.1107 14.2738C16.3506 13.9795 16.2687 13.642 15.9564 13.468L15.2515 13.0751C14.6927 12.7636 14.4134 12.6079 14.1172 12.6388C13.821 12.6697 13.5798 12.8797 13.0973 13.2997L11.7759 14.4501Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 4.75L0.75 4.75M3.25 10.75L0.75 10.75M3.25 16.75H0.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function HeadsetIcon({ className }: { className?: string }) {
  return (
    <svg
      width="19.5"
      height="21.5"
      viewBox="0 0 19.5 21.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M12.75 10.75C12.75 9.64543 13.6454 8.75 14.75 8.75C16.9591 8.75 18.75 10.5409 18.75 12.75C18.75 14.9591 16.9591 16.75 14.75 16.75C13.6454 16.75 12.75 15.8546 12.75 14.75V10.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M6.75 10.75C6.75 9.64543 5.85457 8.75 4.75 8.75C2.54086 8.75 0.75 10.5409 0.75 12.75C0.75 14.9591 2.54086 16.75 4.75 16.75C5.85457 16.75 6.75 15.8546 6.75 14.75V10.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M0.75 12.75V9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75V14.5962C18.75 16.6045 18.75 17.6086 18.3976 18.3917C17.9965 19.2829 17.2829 19.9965 16.3917 20.3976C15.6086 20.75 14.6045 20.75 12.5962 20.75H9.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function LaptopProgrammingIcon({ className }: { className?: string }) {
  return (
    <svg
      width="18.1664"
      height="17.3333"
      viewBox="0 0 18.1664 17.3333"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M15.7499 10.75V4.08334C15.7499 2.51199 15.7499 1.72631 15.2617 1.23816C14.7736 0.750003 13.9879 0.750003 12.4166 0.750003H5.74989C4.17854 0.750003 3.39286 0.750003 2.90471 1.23816C2.41655 1.72631 2.41655 2.51199 2.41655 4.08334V10.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.9979 11.5962L2.43283 10.75H15.7097L16.1685 11.5962C17.3709 13.8141 17.6704 14.9231 17.2133 15.7532C16.7563 16.5833 15.5445 16.5833 13.121 16.5833L5.0454 16.5833C2.6219 16.5833 1.41015 16.5833 0.953113 15.7532C0.496077 14.9231 0.795507 13.8141 1.9979 11.5962Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9999 4.5L12.7665 5.16075C13.0888 5.43852 13.2499 5.57741 13.2499 5.75C13.2499 5.92259 13.0888 6.06148 12.7665 6.33926L11.9999 7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.16655 4.5L5.39997 5.16075C5.07769 5.43852 4.91655 5.57741 4.91655 5.75C4.91655 5.92259 5.07769 6.06148 5.39997 6.33926L6.16655 7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91655 3.66667L8.24989 7.83334"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function MessageMultipleIcon({ className }: { className?: string }) {
  return (
    <svg
      width="18.1667"
      height="18.1667"
      viewBox="0 0 18.1667 18.1667"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M5.57582 14.9167C5.30387 14.8067 5.15368 14.7535 5.06966 14.7638C4.9664 14.7764 4.81659 14.8864 4.51695 15.1063C3.98864 15.494 3.32308 15.7725 2.33607 15.7486C1.83698 15.7365 1.58743 15.7304 1.47571 15.5409C1.36399 15.3513 1.50313 15.0889 1.78141 14.5641C2.16736 13.8362 2.41189 13.0029 2.04136 12.3352C1.4032 11.3815 0.861132 10.2521 0.781921 9.03227C0.73936 8.37685 0.73936 7.6981 0.781921 7.04268C0.999409 3.69345 3.64254 1.02563 6.96077 0.806112C8.09051 0.731373 9.27244 0.73122 10.4045 0.806112C13.7086 1.0247 16.3434 3.67082 16.5804 7"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3314 17.1226C9.23986 16.9885 7.57387 15.3581 7.43679 13.3114C7.40996 12.9109 7.40996 12.4961 7.43679 12.0955C7.57387 10.0488 9.23986 8.41844 11.3314 8.28429C12.0449 8.23852 12.7899 8.23862 13.502 8.28429C15.5935 8.41844 17.2595 10.0488 17.3965 12.0955C17.4234 12.4961 17.4234 12.9109 17.3965 13.3114C17.3466 14.0568 17.005 14.747 16.6027 15.3299C16.3692 15.7379 16.5233 16.2471 16.7666 16.6919C16.942 17.0127 17.0297 17.173 16.9592 17.2889C16.8888 17.4047 16.7315 17.4084 16.417 17.4158C15.7948 17.4304 15.3753 17.2602 15.0423 17.0233C14.8535 16.8889 14.759 16.8217 14.6939 16.814C14.6289 16.8063 14.5008 16.8572 14.2447 16.959C14.0145 17.0504 13.7472 17.1069 13.502 17.1226C12.7899 17.1683 12.0449 17.1684 11.3314 17.1226Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function PackageDeliveredIcon({ className }: { className?: string }) {
  return (
    <svg
      width="17.3335"
      height="18.1667"
      viewBox="0 0 17.3335 18.1667"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M15.75 13.25V9.08333M0.75 13.25C0.75 10.6962 0.75 5.10484 0.75 4.78226C0.75 3.63018 2.37137 2.94527 5.61411 1.57545C6.91682 1.02515 7.56818 0.75 8.25 0.75L8.25 9.62097"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 3.25C10.75 3.25 11.4792 3.25 12.2083 1.58333C12.2083 1.58333 14.5245 5.75 16.5833 6.58333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.18827 11.0072L2.75393 12.1851C1.41798 12.8316 0.75 13.1548 0.75 13.6667C0.75 14.1785 1.41798 14.5018 2.75393 15.1482L5.18827 16.3262C6.6907 17.0532 7.44191 17.4167 8.25 17.4167C9.05809 17.4167 9.8093 17.0532 11.3117 16.3262L13.7461 15.1482C15.082 14.5018 15.75 14.1785 15.75 13.6667C15.75 13.1548 15.082 12.8316 13.7461 12.1851L11.3117 11.0072C9.8093 10.2802 9.05809 9.91667 8.25 9.91667C7.44191 9.91667 6.6907 10.2802 5.18827 11.0072Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 9.08333L4.91667 8.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4167 15.75L4.08333 11.5833"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function ShelvingUnitIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className={className} aria-hidden>
      <g>
        <path
          d="M4.16016 2.5V17.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M4.16016 10H15.8268"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M15.8268 2.5V17.5"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M4.16016 4.16667H15.8268"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M4.16016 15.8333H15.8268"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
        />
        <path
          d="M9.99349 14.1667C9.99349 13.381 9.99349 12.9882 10.2376 12.7441C10.4817 12.5 10.8745 12.5 11.6602 12.5C12.4458 12.5 12.8387 12.5 13.0827 12.7441C13.3268 12.9882 13.3268 13.381 13.3268 14.1667V15.8333H9.99349V14.1667Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <path
          d="M6.66016 8.33333C6.66016 7.54766 6.66016 7.15482 6.90423 6.91074C7.14831 6.66667 7.54115 6.66667 8.32682 6.66667C9.1125 6.66667 9.50533 6.66667 9.74941 6.91074C9.9935 7.15482 9.9935 7.54766 9.9935 8.33333V10H6.66016V8.33333Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function TradeUpIcon({ className }: { className?: string }) {
  return (
    <svg
      width="17.5"
      height="9.5"
      viewBox="0 0 17.5 9.5"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <path
          d="M16.75 5.75V0.75H11.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.75 0.75L11.75 5.75C10.8674 6.63256 10.4262 7.07385 9.88457 7.12263C9.79504 7.1307 9.70496 7.1307 9.61543 7.12263C9.07385 7.07385 8.63256 6.63256 7.75 5.75C6.86744 4.86744 6.42615 4.42615 5.88457 4.37737C5.79504 4.3693 5.70496 4.3693 5.61543 4.37737C5.07385 4.42615 4.63256 4.86744 3.75 5.75L0.75 8.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function Truck20Icon({ className }: { className?: string }) {
  return (
    <svg
      width="18.1668"
      height="14.8334"
      viewBox="0 0 18.1668 14.8334"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <circle cx="13.25" cy="12.4168" r="1.66667" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="4.91667" cy="12.4168" r="1.66667" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M3.25 12.3938C2.33606 12.3482 1.76592 12.2123 1.36019 11.8066C0.954469 11.4008 0.818515 10.8307 0.772959 9.91676M6.58333 12.4168H11.5833M14.9167 12.3938C15.8306 12.3482 16.4007 12.2123 16.8065 11.8066C17.4167 11.1964 17.4167 10.2143 17.4167 8.25009V6.58342H13.5C12.8796 6.58342 12.5694 6.58342 12.3183 6.50185C11.8109 6.33699 11.4131 5.93918 11.2482 5.43179C11.1667 5.18073 11.1667 4.87052 11.1667 4.25009C11.1667 3.31945 11.1667 2.85413 11.0443 2.47755C10.797 1.71645 10.2003 1.11974 9.43921 0.872449C9.06263 0.750091 8.59731 0.750091 7.66667 0.750091H0.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 4.08342H5.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 6.58342H4.08333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1667 2.41676H12.6844C13.8971 2.41676 14.5035 2.41676 14.997 2.71152C15.4905 3.00627 15.778 3.54018 16.353 4.60801L17.4167 6.58342"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function Truck24Icon({ className }: { className?: string }) {
  return (
    <svg
      width="21.5001"
      height="17.5001"
      viewBox="0 0 21.5001 17.5001"
      fill="none"
      className={className}
      aria-hidden
    >
      <g>
        <circle cx="15.75" cy="14.7501" r="2" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="5.75" cy="14.7501" r="2" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M3.75 14.7225C2.65328 14.6679 1.9691 14.5047 1.48223 14.0178C0.995363 13.531 0.832218 12.8468 0.77755 11.7501M7.75 14.7501H13.75M17.75 14.7225C18.8467 14.6679 19.5309 14.5047 20.0178 14.0178C20.75 13.2856 20.75 12.1071 20.75 9.75007V7.75007H16.05C15.3055 7.75007 14.9332 7.75007 14.632 7.65218C14.0231 7.45435 13.5457 6.97698 13.3479 6.3681C13.25 6.06684 13.25 5.69458 13.25 4.95007C13.25 3.8333 13.25 3.27492 13.1032 2.82302C12.8064 1.90971 12.0904 1.19366 11.1771 0.896901C10.7252 0.750071 10.1668 0.750071 9.05 0.750071H0.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 4.75007H6.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.75 7.75007H4.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.25 2.75007H15.0712C16.5266 2.75007 17.2542 2.75007 17.8464 3.10378C18.4386 3.45749 18.7836 4.09818 19.4736 5.37957L20.75 7.75007"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

// Cercle « ? » (help-circle) — onglet placeholder « Process 4 — à confirmer » (Figma 10263:2390).
export function HelpCircleIcon({ className }: { className?: string }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} aria-hidden>
      <g>
        <path
          d="M7 12.8333C10.2217 12.8333 12.8333 10.2217 12.8333 7C12.8333 3.77834 10.2217 1.16667 7 1.16667C3.77834 1.16667 1.16667 3.77834 1.16667 7C1.16667 10.2217 3.77834 12.8333 7 12.8333Z"
          stroke="currentColor"
          strokeWidth="1.16667"
        />
        <path
          d="M5.3025 5.25C5.43964 4.86014 5.71034 4.5314 6.06664 4.32199C6.42294 4.11259 6.84186 4.03605 7.24919 4.10592C7.65652 4.17578 8.02598 4.38756 8.29213 4.70372C8.55828 5.01989 8.70395 5.42005 8.70333 5.83333C8.70333 7 6.95333 7.58333 6.95333 7.58333"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeLinecap="round"
        />
        <path
          d="M7 9.91667H7.00583"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
